import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { getLocalized } from '../../redux/localization';
import Form, { GroupItem, SimpleItem } from "devextreme-react/form";
import {
    Label,
    CustomRule,
    RequiredRule,
    EmailRule,
} from "devextreme-react/form";
import {newAccount } from './types';

export const renderInformationItem = (item: any) => {
    if (item.editorOptions.value !== null) {
        return <span>{item.editorOptions.value}</span>;
    } else {
        return <span>-</span>;
    }
};
const CreateUserForm = forwardRef<any, { data: newAccount }>(
    ({ data }, ref) => {
        const localize = useSelector(getLocalized);
        const checkPassword = (str: any) => {
            var re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{6,}$/;
            return re.test(str.value);
        };
       
        const passwordEditorOptions = {
          
            mode: "password",
            defaultValue: "1q2w3E**",
        };
        return (
            <form>
                <Form
                    ref={ref}
                    key="id"
                    labelLocation="left"
                    formData={data}
                    showColonAfterLabel={true}
                    validationGroup='createUserFormValidation'
                >
                    <GroupItem colCount={2} >
                        <SimpleItem
                            dataField={"name"}
                            editorType={"dxTextBox"}
                            editorOptions={{
                                inputAttr: {
                                    style: " text-transform: capitalize",
                                },
                            }}
                            label={{ text: "İsim" }}
                        >
                            <Label visible={false} />
                            <RequiredRule message={localize.getString("required")} />
                        </SimpleItem>
                        <SimpleItem
                            dataField={"surname"}
                            editorType={"dxTextBox"}
                            editorOptions={{
                                inputAttr: {
                                    style: " text-transform: capitalize",
                                },
                            }}
                            label={{ text: "Soyisim" }}
                        >
                            <RequiredRule message={localize.getString("required")} />
                            <Label visible={false} />
                        </SimpleItem>
                        <SimpleItem
                            dataField={"email"}
                            editorType={"dxTextBox"}
                            label={{ text: localize.getString("email") }}
                        >
                            <RequiredRule message={localize.getString("required")} />
                            <EmailRule message={localize.getString("email")} />
                            <Label visible={false} />
                        </SimpleItem>
                        <SimpleItem
                            dataField={"password"}
                            editorType={"dxTextBox"}
                            editorOptions={passwordEditorOptions}
                            label={{ text: localize.getString("password") }}
                        >
                            <CustomRule
                                validationCallback={(e: any) => checkPassword(e)}
                                message="Şifre en az bir büyük harf,bir rakam,bir küçük harf,bir özel karakter içermelidir."
                            />
                            <RequiredRule message={localize.getString("required")} />

                            <Label visible={false} />
                        </SimpleItem>
                        <SimpleItem
                            dataField={"accountName"}
                            editorType={"dxTextBox"}
                            label={{ text: localize.getString("accountName") }}
                        >
                            <RequiredRule message={localize.getString("required")} />
                            <Label visible={false} />
                        </SimpleItem>
                        <SimpleItem
                            dataField={"phone"}
                            editorType={"dxTextBox"}
                            helpText="Telefon numarasını 10 karakterli olarak giriniz"
                            editorOptions={{
                                mask: "(X00) 000-0000",
                                maskRules: {
                                    X: /[02-9]/,
                                },
                                maskInvalidMessage:
                                    "Telefon numarasını 10 karakterli olarak giriniz",
                            }}
                            label={{ text: localize.getString("phone") }}
                        >
                            <RequiredRule message={localize.getString("required")} />
                            <Label visible={false} />
                        </SimpleItem>
                    </GroupItem>
                </Form>
            </form>
        );
    }
);

export default CreateUserForm;